import { useMsal } from '@azure/msal-react';
import { models } from "powerbi-client";
import React, { useState, useEffect } from 'react'
import { PowerBIEmbed } from 'powerbi-client-react';
import './PowerBiReport.css';
import { loadPowerBiReport, PowerBiReportType } from '../services/powerBiApi';

interface PowerBiReportProps {
    reportType: PowerBiReportType;
}

const PowerBiReport = ({ reportType }: PowerBiReportProps) => {
    const [currentReportId, setCurrentReportId] = React.useState<string | null>(null);
    const { instance } = useMsal();
    const [powerBiAccessToken, setPowerBiAccessToken] = useState<string>(() => {
        const saved = localStorage.getItem('powerBiAccessToken');
        return saved ? JSON.parse(saved) : null;
    });
    const [powerBiEmbedUrl, setPowerBiEmbedUrl] = useState<string | null>(null);

    const loadReport = async () => {
        const reportInfo = await loadPowerBiReport(instance, reportType);
        setCurrentReportId(reportInfo.reportId);
        setPowerBiEmbedUrl(reportInfo.embedUrl);
        setPowerBiAccessToken(reportInfo.accessToken);
    }
    useEffect(() => {
        loadReport();
    }, []);

    if (currentReportId === null || powerBiEmbedUrl === null || powerBiAccessToken == null) {
       return (<div></div>);
    }
    else {
        return (
            <PowerBIEmbed
                embedConfig={{
                    type: 'report',
                    id: currentReportId,
                    embedUrl: powerBiEmbedUrl,
                    accessToken: powerBiAccessToken,
                    tokenType: models.TokenType.Aad
                }}
                eventHandlers={
                    new Map([
                        ['loaded', function () { console.log('Report loaded'); }],
                        ['rendered', function () { console.log('Report rendered'); }],
                        ['error', function (event) { console.log(event.detail); }],
                        ['visualClicked', () => console.log('visual clicked')],
                        ['pageChanged', (event) => console.log(event)],
                    ])
                }
                cssClassName={reportType == PowerBiReportType.Overview ? "report-container-small" : "report-container"} />)
    }
};

export default PowerBiReport; 